<!--
   Created by qing on 2020/12/21
   Des: 发起表单弹窗
-->
<template>
  <div>
    <van-popup
      class="select-apply-form-popup"
      v-model="selectFormVisible"
      get-container="body"
      safe-area-inset-bottom
      :style="{ height: '90%', width: '100%' }"
      position="bottom">

      <div v-if="!loading && (!currentApps || !currentApps.length)" class="select-apply-form-empty">
        <img src="../../../assets/images/empty.png" alt="">
        暂无应用
      </div>

      <template v-else>
        <van-tree-select
          v-if="selectFormVisible"
          :items="currentApps"
          @click-nav="didSelectApp"
          @click-item="didSelectForm"
          :main-active-index.sync="appIndex"
          :active-id.sync="allSelectForms">
          <template
            #content
            v-if="!formsLoading && currentApps[appIndex] && (!currentApps[appIndex].children || !currentApps[appIndex].children.length)">
           <div
             class="empty-forms">
             暂无可以发起的表单
           </div>
          </template>
        </van-tree-select>

        <create-form-apply
          v-if="selectForm"
          ref="createFormApply"
          :app-id="selectForm.appId"
          :formId="selectForm.formId"
          :needButton="false"
          @submitCallback="applySuccess">
        </create-form-apply>
      </template>

    </van-popup>
  </div>
</template>

<script>
  import {FORM_TYPE_FORM} from "../../RyForm/types";
  import CreateFormApply from "../CreateFormApply";

  export default {
    data() {
      return {
        loading: true,
        formsLoading: true,
        selectFormVisible: false,
        currentApps: [],
        appIndex: 0,
        allSelectForms: [],
        selectForm: null,
      }
    },
    components: {CreateFormApply},
    created() {

    },
    methods: {
      open() {
        this.loading = true
        this.appIndex = 0
        this.selectForm = null
        this.allSelectForms.splice(0, this.allSelectForms.length)
        this.selectFormVisible = true

        this.currentApps.splice(0, this.currentApps.length)
        const loading = this.$toast.loading()
        this.$store.dispatch('getApps')
          .then(resultObject => {
            resultObject.allAppList.forEach(app => {
              this.currentApps.push({
                ...app,
                text: app.appName,
                id: app.appId,
                children: []
              })
            })
            this.didSelectApp(0)
          }).catch(console.error)
          .finally(() => {
            this.loading = false
            loading.clear()
          })
      },
      close() {
        if (this.$refs.createFormApply) {
          this.$refs.createFormApply.close()
        }
        this.selectFormVisible = false
      },
      didSelectApp(index) {
        this.appIndex = index
        const app = this.currentApps[index]
        if (!app) {
          return
        }
        this.formsLoading = true
        app.children.splice(0, app.children.length)
        this.$store.dispatch('getForms', app.appId)
          .then(resultObject => {
            if (resultObject && resultObject.length) {
              const forms = resultObject.filter(form => form.contentType === FORM_TYPE_FORM)
              forms.forEach(form => {
                if (form.canTypeData) {
                  app.children.push({
                    text: form.name,
                    id: form.relateId,
                    ...form
                  })
                }
              })
            }
          })
          .catch(console.error)
          .finally(() => {this.formsLoading = false})
      },
      didSelectForm(data) {
        this.selectForm = data
        this.selectFormVisible = false
        setTimeout(() => {
          if (this.$refs.createFormApply) {
            this.$refs.createFormApply.onClickCreate()
          }
        }, 500)
      },
      applySuccess(data) {
        console.log(data)
        this.$emit('applySuccess', {
          ...data,
          appId: this.selectForm.appId,
          formId: this.selectForm.formId,
        })
      }
    }
  }
</script>

<style lang="less">

  .select-apply-form-popup {

    .select-apply-form-empty {
      width: 100%;
      height: 100%;
      display: flex;
      flex-direction: column;
      justify-content: center;
      align-items: center;

      img {
        width: 300px;
      }
    }

    .van-tree-select {
      height: 100% !important;

      .van-tree-select__item {
        border-bottom: 1px solid #f4f4f4;
      }

      .empty-forms {
        width: 100%;
        height: 100%;
        display: flex;
        justify-content: center;
        align-items: center;
        color: #5d616f;
        font-size: 14px;
      }
    }

    .van-sidebar-item--select {
      border-color: #4A66FA;
    }

    .van-tree-select__item--active {
      color: #4A66FA;
    }
  }
</style>